import React from 'react'
import { BACK_URL, REGISTER_URL } from './URLConstants';
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';


export default function Banner() {
    return (
        <>
            <div id="tg-homebanner" className="tg-homebanner tg-haslayout">
                <figure className="tg-themepostimg">
                    <img src="images/icdri_banner.png" alt="" />
                    <figcaption>
                        <div className="tg-bannercontent" data-tilt>
                            <span className="tg-datetime">4-5 April 2023</span>
                            <h2 className="head">International Conference on Disaster Resilient Infrastructure (ICDRI) <span>2023</span></h2>
                            <div className="tg-speakerinfo">

                                <div className="tg-btnwhite" style={{ paddingTop: "20px" }}>
                                    {/* <Link to={REGISTER_URL} className="tg-btn" target='_blank'>Register</Link>*/}
                                    <Link to="schedule" className="tg-btn" target='_blank'>View Schedule</Link>

                                </div>
                            </div>
                        </div>
                    </figcaption>
                </figure>
            </div >
        </>
    )
}
